export class PersonalData {
    name = '';
    cpf = '';
    documentName = '';
    photoDocument = '';
    documentType = '';
    documentTypeName = '';
    documentNumber = '';
    issueDate = '';
    issuingAgency = '';
    issuingAgencyName = '';
    expeditionState = '';
    expeditionStateName = '';
    ufOfTheIssuingAgency = '';
    dateOfBirth = '';
    cityOfBirth = '';
    cityOfBirthName = '';
    uFOfBirthName = '';
    uFOfBirth = '';
    countryOfBirthName = '';
    countryOfBirth = '';
    nationality = '';
    nationalityName = '';
    motherName = '';
    gender = '';
    genderName = '';
    selfie = '';
    phoneNumber = '';
    email = '';
    isCompleted?: boolean;
    editData = [];
    firstEdit = [];
    genderCode = '';
    regionBirthFoundation?: string;
    age?: string;
}
